'use client';

import type { SuggestionsListProps } from '../types';
import { SuggestionItem } from './SuggestionItem';

function SuggestionsList({ id, suggestions, highlightedIndex, onSelect, onMouseEnter, onItemKeyDown, ...props }: SuggestionsListProps) {
  return (
    <div className="suggestions-list mt-4 bg-background flex flex-col gap-3" role="listbox" aria-label="Address suggestions" data-testid="suggestions-list" {...props}>
      {suggestions.map((suggestion, index) => (
        <SuggestionItem
          key={suggestion.Id ? `${suggestion.Id}-${index}` : index}
          id={id}
          suggestion={suggestion}
          index={index}
          isHighlighted={highlightedIndex === index}
          onSelect={onSelect}
          onMouseEnter={onMouseEnter}
          onKeyDown={onItemKeyDown}
        />
      ))}
    </div>
  );
}

export { SuggestionsList };
